import { createValidIcon } from '@ui/icons/utils/type-helper'

export const StatusCustomIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M15 1.66699C16.8409 1.66699 18.333 3.15905 18.333 5C18.333 6.84095 16.8409 8.33301 15 8.33301H13.333V11.667H15C16.8409 11.667 18.333 13.1591 18.333 15C18.333 16.8409 16.8409 18.333 15 18.333C13.1591 18.333 11.667 16.8409 11.667 15V13.333H8.33301V15C8.33301 16.8409 6.84095 18.333 5 18.333C3.15905 18.333 1.66699 16.8409 1.66699 15C1.66699 13.1591 3.15905 11.667 5 11.667H6.66699V8.33301H5C3.15905 8.33301 1.66699 6.84095 1.66699 5C1.66699 3.15905 3.15905 1.66699 5 1.66699C6.84095 1.66699 8.33301 3.15905 8.33301 5V6.66699H11.667V5C11.667 3.15905 13.1591 1.66699 15 1.66699ZM5 13.333C4.07953 13.333 3.33301 14.0795 3.33301 15C3.33301 15.9205 4.07953 16.667 5 16.667C5.92047 16.667 6.66699 15.9205 6.66699 15V13.333H5ZM13.333 15C13.333 15.9205 14.0795 16.667 15 16.667C15.9205 16.667 16.667 15.9205 16.667 15C16.667 14.0795 15.9205 13.333 15 13.333H13.333V15ZM8.33301 11.667H11.667V8.33301H8.33301V11.667ZM5 3.33301C4.07953 3.33301 3.33301 4.07953 3.33301 5C3.33301 5.92047 4.07953 6.66699 5 6.66699H6.66699V5C6.66699 4.07953 5.92047 3.33301 5 3.33301ZM15 3.33301C14.0795 3.33301 13.333 4.07953 13.333 5V6.66699H15C15.9205 6.66699 16.667 5.92047 16.667 5C16.667 4.07953 15.9205 3.33301 15 3.33301Z'
        fill={color}
      />
    </svg>
  )
})
